module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAWCAYAAADafVyIAAABHElEQVRIS+WVsUoDQRCG///iC2iTys5GbARLtbC1srEwlYUPIUlmZ7OXaBvRN7AXGxHsRMgLWOQtBNEunhOCGu3ulmMh4FYL8+9+7Mz8sxT11zAcAEbMFycGun7Qy3Z70GwsTUaANX/jVXY0ELcU599A3OAT93+OHZFYCcHvOqdnBrRgPK1y7VyTYQ+GFsXpOwzdPO8Nf4LO6ZUBm3no7Yj4LojjPPi1GICInoAYLgBA/TkMhwlfELbA4jEmPV9aNgB7Lk3RTNrp9Fez7GM7BkLydTxef6gEUNWsAPZjAEa+DLwflQJEwgZYPAFcjgF8a+/KAbWKzItywD/3QaUUJS7yrBuStmlyo4kkHhVSywcLMa7rGy31l5n4058CIJ9xJCoBIpYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/canvasImg/panel/leibie@2x.png
// module id = k+db
// module chunks = 14